module.exports = __webpack_public_path__ + "img/goods10.7d27c5c2.jpg";